import axios from "@/plugins/axios";
import { useStore } from "vuex";
import { FileOpener } from "@awesome-cordova-plugins/file-opener";
import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { useRoute } from "vue-router";
import { appOrigin } from "@/utils/basics";

export function useMessage() {
  const store = useStore();
  const getMessages = async () => {
    // if (store.state.conversations.length === 0) {
    //   store.commit("setShowLoading", true);
    // }
    const response = await axios.get("?Mode=General&Function=GetMessages");
    // console.log(response);
    if (response.data.Status === "Success" && response.data.Result) {
      const conversations = [];
      // console.log(Object.entries(response.data.Result));
      for (const [caseId, conversation] of Object.entries(
        response.data.Result
      )) {
        // console.log(caseId);
        // console.log(conversation);
        const messages = Object.values(conversation).filter(
          (message) => !["appointment", "proposed"].includes(message.Type)
        );
        if (messages.length) {
          conversations.push({
            caseId: caseId,
            messages: messages,
          });
        }
      }
      conversations.sort((a, b) => {
        return (
          new Date(b.messages.at(-1)?.Date) - new Date(a.messages.at(-1)?.Date)
        );
      });
      store.commit("setConversations", conversations);
    }
  };

  const route = useRoute();
  const getMessageFile = async (messageId, path, mimeType, caseId) => {
    if (Capacitor.isNativePlatform()) {
      store.commit("setShowLoading", true);
      const response = await axios.post(
        "?Mode=General&Function=GetMessageFile",
        {
          CaseId: caseId || route.params.caseId,
          MessageId: messageId,
          Base64: true,
        }
      );
      store.commit("setShowLoading", true);
      const writeFileResult = await Filesystem.writeFile({
        path: path,
        data: response.data,
        directory: Directory.External,
        // encoding: Encoding.UTF8,
      });
      await FileOpener.open(writeFileResult.uri, mimeType);
      store.commit("setShowLoading", false);
    } else {
      window.open(
        appOrigin +
          "/arag/api/?Mode=General&Function=GetMessageFile&CaseId=" +
          (caseId || route.params.caseId) +
          "&MessageId=" +
          messageId,
        "_blank"
      );
    }
  };

  const messageTypeMapping = {
    general: "Allgemeine Nachricht",
    costEstimate: "Behandlungsplan/Kostenvoranschlag",
    report: "Befund/Arztbrief",
    costEstimateAnswer: "Kostenvoranschlag Antwort",
    costTakeoverAccept: "Zusage Kostenübernahme",
    costTakeoverAcceptAnswer: "Zusage Kostenübernahme Antwort",
    costTakeoverDecline: "Ablehnung Kostenübernahme",
    participationPolicyMedicalContact: "Teilnahmeerklärung Medical Contact",
    participationPolicyMedicalContactAnswer:
      "Teilnahmeerklärung Medical Contact Antwort",
    consentForm: "Einwilligungserklärung",
    appointment: "Neuer Termin",
    appointmentAccept: "Termin angenommen",
    appointmentDecline: "Termin abgelehnt",
    appointmentCancel: "Termin abgesagt",
    proposed: "Neuer Vorschlag",
    proposedAccept: "Vorschlag angenommen",
    proposedDecline: "Vorschlag abgelehnt",
    serviceBetterDoc: "BetterDoc Service",
    other: "Sonstiges",
  };

  return { getMessages, messageTypeMapping, getMessageFile };
}
